import { Avatar } from "antd";
import React, { useContext } from "react";
import { UserContext } from "../../auth/user-context";
import "./user-button.scss";

export interface UserButtonProps {
  isMobile?: boolean;
  style?: React.CSSProperties;
}

export const UserButton: React.FC<UserButtonProps> = (props) => {
  const { user } = useContext(UserContext);
  return user && <Avatar src={user.photoURL}>{user.displayName}</Avatar>;
};

export default UserButton;
